module.exports = __webpack_public_path__ + "static/media/star-solid.f10a25eb.svg";